import React from 'react';
import PropTypes from 'prop-types';
import {Trans} from '@lingui/react';

import EvaluationItem from '../EvaluationItem';

import s from './EvaluationList.css';

export default function EvaluationList(props) {
  const {campaign, tests, onEnterTest} = props;
  const [createdOn] = campaign?.get('createdOn').split(' ');

  return (
    <div className={s.EvaluationList}>
      {tests?.size < 1 && (
        <h3>
          <Trans id="evaluation_list.no_tests">No tests found</Trans>
        </h3>
      )}

      {tests?.map(t => (
        <EvaluationItem createdOn={createdOn} test={t} onClick={ev => onEnterTest(t.get('id'))} />
      ))}
    </div>
  );
}

EvaluationList.propTypes = {
  onEnterTest: PropTypes.func,
  campaign: PropTypes.object,
  tests: PropTypes.object,
};
